module.exports = "https://coursera_assets.s3.amazonaws.com/images/e289bc6034ba234e6d91be265ad945e9.png";